import { BaseAction } from "./BaseAction";
import { PaywallEngine } from "../engines/PaywallEngine";
import { localStorageService } from "@Engage.Data/services/storage/localStorage/LocalStorageService";
import { StorageKeys } from "@Engage.Data/constants/Constants";
import { eventsService } from "../../../../core/events";
import { AppEvents } from "../../../../core/Engage.Core";
export class PaywallAction extends BaseAction {
    execute() {
        var _a, _b, _c, _d, _e;
        const isDisabled = sessionStorage.getItem("DisablePaywall");
        if (isDisabled)
            return false;
        const config = (_b = (_a = this.action) === null || _a === void 0 ? void 0 : _a.showWhat) !== null && _b !== void 0 ? _b : {};
        const selector = config.Selector;
        const showModalWithoutSelector = (_c = config.ShowModalPaywallWithoutSelector) !== null && _c !== void 0 ? _c : false;
        const notClosable = (_d = config.NotClosable) !== null && _d !== void 0 ? _d : false;
        const makeReRunOnLogin = (_e = config.MakeReRunOnLogin) !== null && _e !== void 0 ? _e : false;
        // ── Content masking ───────────────────────────────────────────────────────
        // Apply mask if selector exists in DOM
        // If ShowModalPaywallWithoutSelector=true, skip masking and show modal directly
        if (selector && !showModalWithoutSelector) {
            const targetExists = !!document.querySelector(selector);
            if (targetExists) {
                PaywallEngine.apply(this.action);
            }
            else if (!showModalWithoutSelector) {
                // selector configured but not found — don't show paywall
                return false;
            }
        }
        // ── Blocking paywall (NotClosable) ────────────────────────────────────────
        // Hide all close buttons before rendering so they never appear
        if (notClosable) {
            this.action = {
                ...this.action,
                showWhat: {
                    ...config,
                    NotClosable: true
                }
            };
            // lock scroll — blocking paywall should prevent page interaction
            document.body.style.overflow = 'hidden';
        }
        // ── Render template ───────────────────────────────────────────────────────
        this.renderTemplate();
        // Hide close buttons after render if NotClosable
        if (notClosable) {
            this.hideCloseButtons();
        }
        // ── MakeReRunOnLogin ──────────────────────────────────────────────────────
        // Store flag so EngageFlow re-runs after successful login
        if (makeReRunOnLogin) {
            localStorageService.set(StorageKeys.IsMakeReRunOnLogin, 'true', { expandKey: false });
        }
        // Mark paywall as fired
        sessionStorage.setItem("PaywallFired", "true");
        eventsService.dispatch(AppEvents.PaywallShown, this.action);
        return true;
    }
    hideCloseButtons() {
        // Find all close buttons in the rendered template and hide them
        document.querySelectorAll('.Mg2-connext [data-dismiss], .Mg2-connext [_data-dismiss], .Mg2-connext .closebtn, .Mg2-connext .fa-times').forEach(btn => {
            btn.style.display = 'none';
            btn.style.pointerEvents = 'none';
        });
    }
}
